// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__ja7FS","total":"Cart_total__RBbU6","actions":"Cart_actions__0OeFh","button--alt":"Cart_button--alt__xq3CK","button":"Cart_button__Wt5KP"};